import { Diamond } from "lucide-react";

const ITEMS = [
  "Pulizia boiler",
  "Lavaggio serpentine",
  "Filtri acqua sanitaria",
  "Rapporto documentato",
  "Prezzi chiari",
  "Ticino · Mendrisiotto",
];

export const Marquee = ({ dark = false }) => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${
        dark ? "border-avorio/10 bg-antracite" : "border-ink/10 bg-beige"
      } py-5 select-none`}
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span
                  className={`font-display font-light text-lg md:text-xl tracking-wide whitespace-nowrap px-8 ${
                    dark ? "text-avorio/50" : "text-ink/50"
                  }`}
                >
                  {item}
                </span>
                <Diamond className="w-2 h-2 text-bronzo/70" fill="currentColor" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
